import { DataGrid } from "@material-ui/data-grid";
import React, { useRef, useState, useEffect } from "react";
import IPcamera from "../../../Assets/Images/ipCamera.png";
import {
  AddItemContainer,
  ApplyFormInput,
  BoldText,
  Button,
  ButtonContainer,
  DeleteButton,
  EditButton,
  Error,
  ImageInput,
  ImageInputArea,
  InputDiv,
  Label,
  Select,
  style,
  SubmitButton,
  TableContainer,
  TableImage,
  TopBar,
  UploadButton,
  UploadInput,
} from "../../../styles/styles";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { removeFromInventory } from "../../../Redux/actions/InventoryActions";
import ModalInventory from "./ModalInventory";
import GenInventory from "./GenInventory";

const columns = [
  {
    field: "photos",
    headerName: "Photos",
    width: 100,
    sortable: true,
    align: "center",
    renderCell: (params) => {
      return (
        <TableImage>
          <img
            src={params.row.photos}
            alt={params.id}
            height="56px"
            width="55px"
          />
        </TableImage>
      );
    },
  },
  {
    field: "name",
    headerName: "Name",
    width: 150,
    sortable: true,
    align: "center",
  },
  {
    field: "sku",
    headerName: "SKU",
    align: "center",
    type: "number",
    width: 120,
    sortable: true,
  },
  {
    field: "condition",
    headerName: "Condition",
    width: 120,
    align: "center",
    sortable: true,
  },
  {
    field: "location",
    headerName: "Location",
    align: "center",
    width: 150,
    sortable: true,
  },
  {
    field: "available",
    headerName: "Available",
    width: 110,
    type: "number",
    align: "center",
    sortable: true,
  },
  {
    field: "reserved",
    headerName: "Reserved",
    width: 130,
    type: "number",
    align: "center",
    sortable: true,
  },
  {
    field: "onHand",
    headerName: "On Hand",
    type: "number",
    width: 110,
    align: "center",
    sortable: true,
  },
];

const Inventory = ({ inventories, removeFromInventory }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [show, setShow] = useState("inventory");
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [details, setDetails] = useState({});

  const handleOpen = () => {
    setOpen(true);
  };

  const handleDelete = async () => {
    await removeFromInventory(selectedItems);
    setSelectedItems([]);
    handleOpen();
  };
  const editFunc = (item, info) => {
    setDetails({ ...item[0], info });
    info === "edit" && setShow("edit_inventory");
  };

  return (
    <section>
      <TopBar>
        <div className="d-flex">
          <BoldText> Inventory </BoldText>
          {show === "inventory" && (
            <ButtonContainer
              className={selectedItems.length ? "visible mx-lg-4" : "invisible"}
            >
              <DeleteButton onClick={handleDelete}> Delete </DeleteButton>
              <EditButton
                className={selectedItems.length === 1 ? "visible" : "invisible"}
                onClick={() => editFunc(selectedItems, "edit")}
              >
                Edit
              </EditButton>
            </ButtonContainer>
          )}
        </div>

        {show === "inventory" ? (
          <Button
            onClick={() => {
              setShow("addItem");
              setSelectedItems([]);
              setEdit(false);
            }}
          >
            + Add Items
          </Button>
        ) : (
          <Button
            outline
            onClick={() => {
              setSelectedItems([]);
              setEdit(false);
              setDetails({});
              setShow("inventory");
            }}
          >
            View Inventory
          </Button>
        )}
      </TopBar>
      <ModalInventory open={open} setOpen={setOpen} />
      {show === "inventory" ? (
        <TableContainer className="overflow-hidden">
          <DataGrid
            rows={inventories}
            style={style.table}
            columns={columns}
            pageSize={10}
            rowHeight={65}
            autoPageSize
            autoHeight
            hideFooterSelectedRowCount
            disableColumnMenu
            checkboxSelection
            scrollbarSize={5}
            classes={"MuiDataGrid-columnHeader--alignCenter"}
            onSelectionModelChange={(e) => {
              let selectedItemsIdArray = e;
              let selectedItems = [];
              selectedItemsIdArray.forEach((id) =>
                selectedItems.push(inventories.find((row) => row.id === id))
              );
              setSelectedItems(selectedItems);
            }}
          />
        </TableContainer>
      ) : (
        <>
          {show === "addItem" || show === "edit_inventory" ? 
            <GenInventory details={details} setShow={setShow}/> : (
            ""
          )}
        </>
      )}
    </section>
  );
};

const mapStateToProps = (state) => state;
const mapDispatchToProps = {
  removeFromInventory: removeFromInventory,
};
export default connect(mapStateToProps, mapDispatchToProps)(Inventory);
